import { ApiProject } from "@incendium/api";
import { getOnboading } from "features/onboarding/services/onboardingService";
import { useProjectSharedState } from "Hooks/useSharedState";

export const useOnboarding = () => {
  const fetch = async (project: ApiProject) => {
    const res = await getOnboading(project.id as number);
    return res;
  };

  const { state, setState, loading, fetched } = useProjectSharedState(
    "onboarding",
    {},
    fetch
  );

  return {
    onboarding: state,
    setOnboarding: setState,
    loading,
    fetched,
  };
};
